import { Box, Modal } from '@/common/components';
import { FC } from 'react';
import Scheduler from '../Scheduler/Scheduler';
import { Sizes } from '@/common/types';
import { RescheduleAppointmentModalProps } from './RescheduleAppointmentModal.types';
import { useTranslation } from 'react-i18next';
import { GENETIC_COUNSELING_TRANSLATION } from '../../constants';
import {
  StyledApptInfoContainer,
  StyledApptInfoTitle,
  StyledApptInfoValue,
  StyledContentContainer,
  StyledTitle,
} from './RescheduleAppointmentModal.styles';
import { formatDate } from '@/common/utils';

const RescheduleAppointmentModal: FC<RescheduleAppointmentModalProps> = ({ appointmentData, show, onClose }) => {
  const { t } = useTranslation(GENETIC_COUNSELING_TRANSLATION);

  const appointmentInfo = [
    {
      id: 'appt-date',
      label: t('upcoming.counseling_status_card.appointment_date'),
      value: appointmentData && formatDate(appointmentData.date),
    },
    {
      id: 'appt-time',
      label: t('upcoming.counseling_status_card.appointment_time'),
      value: appointmentData?.time,
    },
    {
      id: 'appt-type',
      label: t('upcoming.counseling_status_card.appointment_type'),
      value: appointmentData?.type,
    },
  ];

  return (
    <Modal
      show={show}
      css={{
        overflow: 'unset',
        padding: '0',
      }}
      size={Sizes.XXXX_LARGE}
      title={t('reschedule_appointment.title')}
      titleAlignment="center"
      titleColor={'$primary'}
      onClose={onClose}
    >
      <Box
        css={{
          margin: '$8 $8 0 $8',
          borderBottom: '1px solid $coolGray200',
        }}
      >
        <StyledTitle>{t('reschedule_appointment.current_appointment')}</StyledTitle>
        <StyledContentContainer>
          {appointmentInfo?.map((item) => {
            const isLastItem = item !== appointmentInfo[appointmentInfo.length - 1];
            return (
              <StyledApptInfoContainer
                css={{ borderRight: `${isLastItem ? '1px solid $seafoam500' : 'none'}` }}
                key={item.id}
              >
                <StyledApptInfoTitle data-testid={`counseling-status-card-info-${item.id}-label`}>
                  {item.label}
                </StyledApptInfoTitle>
                <StyledApptInfoValue data-testid={`counseling-status-card-info-${item.id}-value`}>
                  {item.value}
                </StyledApptInfoValue>
              </StyledApptInfoContainer>
            );
          })}
        </StyledContentContainer>
      </Box>
      <Scheduler isReschedulerFlow />
    </Modal>
  );
};

export default RescheduleAppointmentModal;
